<template>
  <div>
    <ul class="divide-y text-xs break-words">
      <OrderLine
        :order-item="getRootOrderItem(orderItemParentOrderItem)"
        :focused-order-item-id="current"
        @order-line:focus="$emit('order-line:changed', $event)"
      />
    </ul>
  </div>
</template>

<script>
import OrderLine from './OrderLine.vue';

export default {
  name: 'OrderLinesNav',

  components: {
    OrderLine,
  },

  props: {
    orderItemParentOrderItem: {
      type: Object,
      required: true,
    },
    current: {
      type: String,
      required: true,
    },
  },

  methods: {
    getRootOrderItem(orderItem) {
      if (!orderItem?.parentOrderItemUuid) return orderItem;

      const parentOrderItem =
        this.$store.state.entities.orderItems.byId[orderItem.parentOrderItemUuid];

      if (!parentOrderItem) return orderItem;

      return this.getRootOrderItem(parentOrderItem);
    },
  },
};
</script>
